import React from 'react';

interface PanelContainerProps {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
}

export const PanelContainer: React.FC<PanelContainerProps> = ({ title, onClose, children }) => (
  <div className="panel-overlay">
    <div className="panel">
      <div className="panel-header">
        <h2>{title}</h2>
        <button className="btn-icon" onClick={onClose} title="Close panel" aria-label="Close">✕</button>
      </div>
      <div className="panel-body">
        {children}
      </div>
    </div>
  </div>
);
